import {BaseService} from './Core/BaseService';

class ContextFileService extends BaseService {
    get Url() { return super.Url + "/contextFiles"; }

    GetContextFiles(contextNodeId, search) {
        const request = {
            contextNodeId: contextNodeId,
            search: search
        };

        return this.SendRequest(BaseService.GET, request);
    }
}

export const service = new ContextFileService();

